import { useState } from 'react'
import { useStore } from '@tanstack/react-store'
import { Navigate } from 'react-router-dom'
import { authStore } from '@/store/authStore'
import { SignInForm } from '@/components/auth/SignInForm.tsx'
import { ForgotPasswordForm } from '@/components/auth/ForgotPasswordForm.tsx'

type Step = 'sign-in' | 'forgot-password'

export function AuthPage() {
  const [step, setStep] = useState<Step>('sign-in')
  const user = useStore(authStore, (state) => state.user)
  const emailVerified = useStore(authStore, (state) => state.emailVerified)
  const isRecoverySession = useStore(authStore, (state) => state.isRecoverySession)

  // If user is logged in and email verified (but not in recovery mode), redirect to subscriptions
  if (user && emailVerified && !isRecoverySession) {
    return <Navigate to="/subscriptions/manage" replace />
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-[#E8E4F0] to-[#D6E5F0] p-4 sm:p-8">
      <div className="w-full max-w-md">
        {step === 'sign-in' && (
          <SignInForm
            onForgotPassword={() => setStep('forgot-password')}
          />
        )}

        {step === 'forgot-password' && (
          <ForgotPasswordForm
            onBackToSignIn={() => setStep('sign-in')}
          />
        )}
      </div>
    </div>
  )
}
